<!--
  This code is the intellectual property of Bulb Inc. and other software publishers;
  it may not be altered, copied or disclosed without prior written approval.
  Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
            _
    _            | | _
   | |         _ | || |
   | |__   _  | || || |__
   | '_ \ | | | || || '_ \
  | (_) || |_| || || (_) |
   \___/  \___/ |_| \___/
-->

<div class="bulb-modal-body-nested">
  <svg-icon class="cross-icon" role="button" aria-label="Close Dialog" (click)="closeDialog()" key="times"></svg-icon>
  <div class="modal-header">
    <svg-icon class="trash-icon" role="button" aria-label="Trash Icon" key="trash-alt"></svg-icon>
    <p class="body-title">{{bodyTitle}}</p>
    <p class="body-text">{{bodyText}}</p>
  </div>
</div>
<div class="bulb-button-d-flex">
<aero-button (onClick)="closeDialog()" [styleClass]="'delete-modal-buttons button-margin-right'"
             [aeroStyle]="buttonStyleGrey"
             [size]="buttonSize"
             labelCode="editor_button_cancel">
</aero-button>
<aero-button (onClick)="deleteBlock()" [styleClass]="'delete-modal-buttons'"
             [aeroStyle]="buttonStyleAlert"
             [size]="buttonSize"
             labelCode="editor_button_delete">
</aero-button>
</div>
